import React, { Component } from 'react';
import { Stack, Grid, IconButton, Link, Typography } from '@mui/material';
import { connect } from 'react-redux';
import Widget from '../common/Widget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faCircle as emptyCircle,
} from '@fortawesome/pro-light-svg-icons';
// import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { faCircle as filledCircle } from '@fortawesome/pro-solid-svg-icons';
import { savePreferences, saveSetup } from '../SetUp/actions';
import { WithSmallScreen } from '../common/WithSmallScreen';
import { AppConfigs } from '../common/ApplicationsList/config';
import { Link as RouterLink } from 'react-router-dom';
import AppsPanel from './AppsPanel';
import { isMobile } from 'react-device-detect';
import PortalTooltip from '../common/PortalTooltip';
import { filterBadData, getSelectedApps, getTotalPanels } from './utils';
import PortalLink from '../common/PortalLink';

class MyApps extends Component {
  //Θ(1) Makes a copy of current prefereneces in setup and resets
  onReset = () => {
    if (Object.keys(this.props.preferences?.Apps?.Apps).length) {
      let setup = { reset: this.props.preferences };
      this.props.savePreferences({});
      this.props.saveSetup(setup);
    } else {
      this.props.savePreferences({});
    }
  };

  state = {
    isExpand: true,
    menu: [],
    active: 1,
    itemsPerPanel: 9,
    noItemsByWidth: {
      xs: 9,
      sm: 9,
      md: 9,
      lg: 9,
      xl: 9,
      xxl: 9,
      '^xxl': 9,
    },
    selectedApps: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.preferences.Apps.Apps !== this.props.preferences.Apps.Apps) {
      const selectedApps = getSelectedApps(this.props.preferences?.Apps?.Apps);
      this.setState({
        selectedApps,
      });
    }
  }

  componentDidMount() {
    const selectedApps = getSelectedApps(this.props.preferences?.Apps?.Apps);
    const menu = [
      //    {id: 'myApps_editFavorites', title: 'Edit Favorites'},
      {
        id: 'myApps_resetSetup',
        title: 'Reset Setup',
        onClick: this.onReset,
      },
    ];
    this.setState({
      selectedApps,
      menu,
    });
  }

  toggleExpand = () => {
    this.setState({ isExpand: !this.state.isExpand });
  };

  //Θ(N) where N is the number of selected apps
  //Returns the next panel in the list
  getNextActive = () => {
    const itemsPerPanel = this.state.noItemsByWidth[this.props.screenSize];
    let lastPanel = getTotalPanels(this.state.selectedApps, AppConfigs, itemsPerPanel);

    if (this.state.active < lastPanel) return this.state.active + 1;
    else return 1;
  };

  //Θ(N) where N is the number of selected apps
  //Returns the previous panel in the list
  getPrevActive = () => {
    const itemsPerPanel = this.state.noItemsByWidth[this.props.screenSize];
    let lastPanel = getTotalPanels(this.state.selectedApps, AppConfigs, itemsPerPanel);

    if (this.state.active > 1) return this.state.active - 1;
    else return lastPanel;
  };

  //Θ(1) Moves to next panel
  onNext = () => {
    this.setState({
      active: this.getNextActive(),
    });
  };

  //Θ(1) Moves to previous panel
  onPrev = () => {
    this.setState({
      active: this.getPrevActive(),
    });
  };

  render() {
    const itemsPerPanel = this.state.noItemsByWidth[this.props.screenSize];
    const filteredApps = filterBadData(this.state.selectedApps, AppConfigs);
    const currentApps = filteredApps?.slice(
      itemsPerPanel * this.state.active - itemsPerPanel,
      itemsPerPanel * this.state.active,
    );
    const noPanels = Math.ceil(filteredApps.length / itemsPerPanel);
    return (
      <React.Fragment>
        <Widget
          data={{
            id: this.props.widget.id,
            title: this.props.title,
            isTitleStylized: this.props.isTitleStylized,
            isMenuDisabled: false,
            menu: this.state.menu,
            isExpand: this.props.widget.isExpand,
            isRequired: this.props.widget.isRequired,
          }}
          {...this.props}
          className="myOdu__myApps"
        >
          <Stack direction="row" justifyContent="end">
            <PortalLink
              id="myApps__link_allApps"
              component={RouterLink}
              to="/allApps"
              className="mb-2"
            >
              All Apps List
            </PortalLink>
          </Stack>
          <Grid container direction="row" justifyContent="center" gap={0.5}>
            <Grid
              item
              container
              className="align-items-center"
              direction="row"
              wrap="nowrap"
              spacing={0}
            >
              {/* Left moving arrow */}
              <Grid item container xs={'auto'} hidden={noPanels <= 1}>
                <Grid item xs="auto">
                  <PortalTooltip title={'Previous Panel'}>
                    <div>
                      <IconButton
                        className={'ms-xs-0 me-xl-3'}
                        sx={{ borderRadius: '0', p: 1 }}
                        aria-label="Previous App Panel"
                        id="myApps__button_prev"
                        onClick={this.onPrev}
                        disabled={noPanels <= 1}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} fixedWidth />
                      </IconButton>
                    </div>
                  </PortalTooltip>
                </Grid>
              </Grid>

              <Grid item xs={12} className="px-0 text-center" style={{}}>
                {currentApps.length != 0 ? (
                  <AppsPanel
                    apps={currentApps}
                    className="appsPanelCenter"
                    itsSmall={this.itsSmall}
                    itemsPerPanel={itemsPerPanel}
                    isMyApps={true}
                  />
                ) : (
                  <div>
                    <Typography component="p" variant="small">
                      No apps found.{' '}
                      <Link style={{ cursor: 'pointer' }} onClick={this.onReset}>
                        Set up apps.
                      </Link>
                    </Typography>
                  </div>
                )}
              </Grid>

              {/* Right movinmg arrow */}
              <Grid item container xs={'auto'} hidden={noPanels <= 1}>
                <PortalTooltip title={'Next Panel'}>
                  <div>
                    <IconButton
                      className={'ms-xs-0 ms-xl-3'}
                      sx={{ borderRadius: '0', p: 1 }}
                      aria-label="Next App Panel"
                      id="myApps__button_next"
                      onClick={this.onNext}
                      disabled={noPanels <= 1}
                    >
                      <FontAwesomeIcon icon={faChevronRight} fixedWidth />
                    </IconButton>
                  </div>
                </PortalTooltip>
              </Grid>
            </Grid>
            {/* Panel Dots */}
            <Grid item container style={{ width: '100%' }} gap={0.5} justifyContent={'center'}>
              {Array(noPanels)
                .fill(0)
                .map((_, idx) => {
                  const isSelected = idx === this.state.active - 1;
                  return (
                    <Grid item>
                      <PortalTooltip
                        title={
                          isSelected
                            ? 'Currently Selected Panel ' + (idx + 1)
                            : 'Go to panel ' + (idx + 1)
                        }
                      >
                        <FontAwesomeIcon
                          icon={isSelected ? filledCircle : emptyCircle}
                          size={isMobile ? 'sm' : '2xs'}
                          onClick={() => {
                            this.setState({
                              active: idx + 1,
                            });
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </PortalTooltip>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Widget>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    preferences: state.preferencesReducer.preferences,
    user: state.AWSReducer.user,
    isImpersonating: state.impersonationReducer.impersonation?.isImpersonating ?? false,
    impersonation: state.impersonationReducer.impersonation,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveSetup: (setup) => dispatch(saveSetup(setup)),
  savePreferences: (preferences) => dispatch(savePreferences(preferences)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithSmallScreen(MyApps));
